<template>
    <div class="copy-dtx-table project-list-table">
    <table class="" :class="{ admin: isTenantAdmin }">
      <thead v-if="showHeader">
        <tr class="m">
          <th v-overflow-tooltip>Name</th>
          <th v-overflow-tooltip>Start Date</th>
          <th v-overflow-tooltip>End Date</th>
          <th v-overflow-tooltip>Created</th>
          <th v-overflow-tooltip>Revenue</th>
          <th v-overflow-tooltip>Copied From</th>
          <th v-overflow-tooltip>Import Status</th>
          <th v-overflow-tooltip>Location</th>
          <th v-overflow-tooltip v-if="showProjectAction">Action</th>
        </tr>
      </thead>
      <tbody v-if="!loading && displayData.length">
        <tr class="s" v-for="row in displayData" :key="row.id">
          <td class="elipsis-text " v-overflow-tooltip >{{ row.name || "--" }}</td>
          <td v-overflow-tooltip >{{ row.planned_start_date | genericFormatDate }}</td>
          <td v-overflow-tooltip >{{ row.planned_end_date | genericFormatDate}}</td>
          <td class="audit-cell">
            <span class="audit-name" v-overflow-tooltip>{{  getFullName(row.tenant_associated_created_by_user?.associated_user) }}</span>
            <span class="audit-date">{{ row.created_on | genericFormatDate }}</span>
          </td>
          <td v-overflow-tooltip>{{ row.project_revenue }}</td>
          <td v-overflow-tooltip>{{ row.project_imports[0]?.copied_from_project?.name || "--" }}</td>
          <td v-overflow-tooltip>
            <span
              v-if="row.project_imports[0]?.import_status"
              :class="['status', getStatusClass(row.project_imports[0]?.import_status.id)]"
              >
              {{ row.project_imports[0]?.import_status?.name }}
            </span>
            <span v-else>--</span>
          </td>
           <td class="location-column" @click="openMaps(row.longitude, row.latitude)">
            <div class="location-content">
                <img src="~@/assets/images/map.svg"
              class="edit pointer map"
              alt=""
              title="Loaction"
              />
              <br/> <label for="">View On Map</label>
            </div>
          </td>
          <td v-if="showProjectAction" class="action-column">
            <div class="action-icons">
              <img src="~@/assets/images/icons/retry-icon.svg"
              class="edit pointer"
              v-if="showRetry(row)"
              alt=""
              v-tooltip="'Retry Import'"
              @click="$emit('retry', row)"
              />
              <img src="~@/assets/images/pencil.svg"
              class="edit pointer"
              alt=""
              v-tooltip="'Edit'"
              @click="$emit('edit', row)"
              />
              <img src="~@/assets/images/trash-2.svg"
              class="delete pointer"
              @click="openDeleteConfirmModal(row)"
              alt=""
              v-tooltip="'Delete'"
              v-if="isTenantAdmin"
              />
            </div>
          </td>
          </tr>
      </tbody>
      <tbody v-else-if="!loading && displayData.length === 0">
        <tr>
      <td colspan="8" class="no-data">
        <div class="center">
              No Data Found
            </div>
      </td>
    </tr>
      </tbody>
      <tbody v-else>
        <tr>
          <td colspan="8">
            <div class="center">
              <loading-circle />
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  </template>

<script>
import LoadingCircle from './loadingCircle.vue'
import { genericFormatDate } from '@/utils/date'
import { mapGetters } from 'vuex'
import ConfirmationDialog from '@/plugins/confirmationDialog'
import Config from '@/config'

export default {
  components: { LoadingCircle },
  data: () => ({
    config: Config
  }),
  filters: {
    genericFormatDate
  },
  name: 'project-table',
  props: {
    projectList: {
      type: Array,
      default: () => []
    },
    pageNumber: {
      type: [Number, String],
      default: 1
    },
    perPage: {
      type: [Number, String],
      default: 10
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    externalCollaborator: {
      type: String
    }
  },
  computed: {
    ...mapGetters(['user', 'getUserById']),
    ...mapGetters(['isTenantAdmin']),
    displayData () {
      return this.projectList.slice(
        (this.pageNumber - 1) * this.perPage,
        this.pageNumber * this.perPage
      )
    },
    isTenantAdmin () {
      return (
        this.user.tenantLevelRole === 'ADMIN' && !this.externalCollaborator
      )
    },
    showProjectAction () {
      return (
        this.user.tenantLevelRole === 'ADMIN' && !this.externalCollaborator)
    }
  },
  methods: {
    getStatusClass (statusId) {
      switch (statusId) {
      case this.config.IMPORT_STATUS.SUCCESS:
        return 'status-success'
      case this.config.IMPORT_STATUS.ERROR:
        return 'status-error'
      default:
        return ''
      }
    },
    showRetry (row) {
      const importStatusId = row.project_imports[0]?.import_status?.id
      const numberOfRetries = row.project_imports[0]?.retries || 0
      return [this.config.IMPORT_STATUS.NONE, this.config.IMPORT_STATUS.ERROR].includes(importStatusId) && numberOfRetries < 2
    },
    openMaps (long, lat) {
      console.log(long, lat)
      if (long && lat) {
        window.open(`https://www.google.com/maps?q=${lat},${long}`, '_blank')
      }
    },
    getFullName (obj) {
      if (obj) {
        return obj?.first_name + ' ' + obj?.last_name
      }
      return '--'
    },
    openDeleteConfirmModal (project) {
      ConfirmationDialog(`Are you sure to delete the project ${project.name}`, (res) => {
        if (res) {
          this.$emit('delete', project)
        }
      })
    }
  }
}
</script>
  <style lang="scss" scoped>
  .no-data {
    text-align: center;
    vertical-align: middle;
  }
  .project-list-table {
    margin-top: 10px;
    max-height: calc(100vh - 250px);
    .status {
  font-size: var(--text-xs1);
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  height: fit-content;
  font-weight: 400;
      padding: 4px 8px;
    border-radius: 6px;
    display: inline-block;
    text-align: center;
}
// .url {
//   width: 20px;
//   height: 20px;
// }

.status-success {
  background-color: #d4edda; /* light green */
  color: #155724;
}

.status-error {
    background-color: rgba(198, 39, 52, 0.1);
    color: rgb(255, 39, 39);
}
  .audit-cell {
    white-space: normal !important;
    line-height: 1.2;
  }
  .audit-name,
  .audit-date {
   display: block;
   overflow: hidden;
   text-overflow: ellipsis;
   white-space: nowrap;
  }
  .audit-name {
   font-size: var(--text-xs2);
   font-weight: 400;
   color: #111827;
  }
  .audit-date {
   margin-top: 4px;
   font-size: var(--text-xs);
   color: #6b7280;
  }
    table th {
      z-index: 1;
    }
    .map {
      z-index: 0;
    }
  }
  </style>
  <!-- <style lang="scss" >
  .project-table {
    width: 100%;
    font-size: var(--text-l);
    border-collapse: collapse;
    position: relative;
    th {
      background: var(--brand-color);
      font-weight: 500;
      padding: 12px 4px;
      position: sticky;
      top: 0;
    }
    td {
      border-bottom: 1px solid var(--brand-color);
    }
    th,
    td {
      text-align: left;
      padding: 8px 4px;
      &:nth-child(1) {
        width: 50px;
        & > img {
          width: 24px;
        }
      }
      & > img {
            width: 24px;
            margin-right: 8px;
      }
    }
    &.admin {
      th,
      td {
        &:last-child {
          width: 80px;
          & > img {
            width: 24px;
            margin-right: 8px;
            &.disabled {
              opacity: 0.5;
              pointer-events: none;
            }
          }
        }
      }
    }
  }
  </style> -->
